





































































































































































































































































































































































































import { AxiosError, AxiosResponse } from 'axios';
import * as L from 'leaflet';
import _ from 'lodash';
import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
import { minLength, minValue, required, requiredIf } from 'vuelidate/lib/validators';

import KendoDropdown from '@/components/kendo-dropdown/kendo-dropdown.vue';

import { IStoreProject } from '@/modules/dap/interfaces';
import { CONFIG } from '@/config';
import { addressService, dateService, httpService, stringService, IAddress, numeralService } from '@/services';
import { CountryEnum } from '@/enums/country.enum';

const iconUrl = require('@/assets/images/pin_default.png'); // tslint:disable-line

@Component({
  components: {
    KendoDropdown
  },
  validations: {
    store: {
      name: {
        required,
        minLength: minLength(2)
      },
      idEconomicGroup: {
        required
      },
      idStoreTypeClient: {
        required,
        minValue: minValue(1)
      },
      percentGrowth: {
        minLength: minLength(0)
      },
      dealerNumber: {
        minLength: minLength(5),
        requiredIf: requiredIf((vueInstance: any) => {
          return vueInstance.idStoreTypeClient === 3;
        })
      },
      idStoreMatrix: {
        minLength: minLength(5)
      },
      neighborhood: {
        minLength: minLength(3)
      },
      dateOpening: {
        required
      },
      cep: {
        minLength: minLength(3)
      },
      idCity: {
        required
      },
      state: {
        required
      }
    }
  }
})
export default class WizardStoreEdit extends Vue {
  $v: any;

  @Prop({ default: false }) open: boolean;

  @Prop({ required: true }) store: IStoreProject;
  @Prop() oldStore: any;

  public worldMap: any;
  public openConfiramation: boolean = false;

  public parseDateToString = dateService.parseDateToString;
  public parseStringToDate = dateService.parseStringToDate;

  public canApplyPermanentChanges = 0;

  public cities: any[] = [];
  public groupsDataSource: any[] = [];
  public storeTypeDataSource = [
    {
      text: '2S',
      value: 2
    },
    {
      text: '3S',
      value: 3
    }
  ];

  public get statesDataSource() {
    return _(this.cities)
      .map((c: any) => ({
        text: c.state,
        value: c.state
      }))
      .uniqBy('value')
      .orderBy('text')
      .value();
  }

  public get citiesDataSource() {
    if (!this.store.state) {
      return [];
    }
    return _(this.cities)
      .filter((c: any) => stringService.normalize(c.state) === stringService.normalize(this.store.state))
      .orderBy('text')
      .value();
  }

  public get modalTitle() {
    if (this.oldStore) {
      return `Buy and Sell - ${this.oldStore.name}`;
    } else if (!this.store.id) {
      return `Adicionar Nova Loja a Matriz - ${this.store.matrixName}`;
    }

    return `Editar Informações - ${this.store.name}`;
  }

  // @Watch('store.idCity')
  // onCityUpdate (target: any) {
  //   const city: any = _.filter(this.cities, (c: any) => c.value === target || c.text === target)[0];
  //
  //   if (city && !this.store.state !== city.state) {
  //     this.store.state = city.state;
  //   }
  // }

  public get productsDataSourceGroup() {
    return _(this.store.salesInformed)
      .orderBy((p: any) => p.name)
      .chunk(5)
      .value();
  }

  @Watch('open')
  public onOpen(openValue: boolean) {
    // if (openValue) {
    if (this.store.idStoreTypeClient === 2) {
      const idProject = this.oldStore ? this.oldStore.projectId : this.store.idProject;
      const idStoreMatrix = this.oldStore ? this.oldStore.id : this.store.idStoreMatrix;
      if (idProject)
        httpService.http
          .get(`${CONFIG.URL.NEODASH_API}/api/dap/store/${idProject}/${idStoreMatrix}/CanPermanentChanges`)
          .then((res: AxiosResponse) => {
            this.canApplyPermanentChanges = res.data ? 1 : 2;
          })
          .catch((err: AxiosError) => console.log(err.message));
    } else {
      this.canApplyPermanentChanges = 1;
    }

    if (this.oldStore) {
      this.store.idStoreBefore = this.oldStore.id;
      this.store.idStoreTypeClient = 3;

      httpService.http
        .get(
          `${CONFIG.URL.NEODASH_API}/api/dap/store/${!this.oldStore ? this.store.id : this.oldStore.id}/pointHistory`
        )
        .then((res: AxiosResponse) => {
          this.store.pointHistories = res.data;
        })
        .catch((err: AxiosError) => console.log(err.message));
    }
    // }
  }

  @Watch('store')
  public onStoreChange(store: IStoreProject) {
    if (!store.idCity && (store.state && store.city)) {
      store.idCity = Number(
        _.find(
          this.cities,
          (c: any) =>
            stringService.normalize(c.state) === stringService.normalize(store.state) &&
            stringService.normalize(c.city) === stringService.normalize(store.city)
        ).value
      ) as any;
    }

    if (!this.$refs.worldMapContainer) {
      return;
    }

    const lat = store.latitude || 0;
    const lng = store.longitude || 0;

    if (this.worldMap) {
      this.worldMap.remove();
    }

    this.worldMap = new L.Map(this.$refs.worldMapContainer as any, {
      center: new L.LatLng(lat, lng),
      zoomControl: false,
      attributionControl: false,
      preferCanvas: true,
      zoom: 12,
      doubleClickZoom: false
    });

    let varAttribution: any = {
      attribution: '',
      maxZoom: 10,
      id: 'mapbox.streets',
      accessToken: 'pk.eyJ1IjoibmVvY29tIiwiYSI6ImJFbml2TlEifQ.qw-OhUelTpK4L6ApHQRXlQ'
    };

    L.tileLayer(
      'https://api.tiles.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}',
      varAttribution
    ).addTo(this.worldMap);

    new L.Marker([lat, lng], {
      icon: L.icon({
        iconUrl: iconUrl,
        iconAnchor: [18, 46]
      })
    }).addTo(this.worldMap);

    this.worldMap.invalidateSize();
  }

  public onChangeDealerNumber() {
    if (this.oldStore || this.store.idStoreTypeClient === 3) {
      this.store.idStoreMatrix = this.store.dealerNumber;
    }
  }

  public onChangeCity(value) {
    this.store.idCity = value;
    var city = this.cities.filter(x => x.value == value)[0];
    this.store.percentGrowth = city.percentGrowth / 100;
  }

  public onChangeLatLng() {
    if (!this.store.latitude && !this.store.longitude) {
      return;
    }

    addressService
      .locationFromLatLng(Number(this.store.latitude), Number(this.store.longitude))
      .then((res: IAddress) => {
        if (!res.address) return;

        this.store.address = res.address;
        this.store.city = res.city;
        this.store.cep = res.zipCode;
        this.store.neighborhood = res.neighborhood;
        this.store.state = res.uf;
      })
      .catch(err => console.log(err));
  }

  public onChangeZipCode() {
    if (!this.store.cep || (this.store.cep + '').length !== 8) {
      return;
    }

    addressService
      .latLngFromZipCode(Number(this.store.cep), CountryEnum.Brasil)
      .then((res: IAddress) => {
        if (!res.address) {
          return;
        }

        this.store.latitude = res.location.lat;
        this.store.longitude = res.location.lng;
        this.store.address = res.address;
        this.store.city = res.city;
        this.store.neighborhood = res.neighborhood;
        this.store.state = res.uf;
      })
      .catch(err => console.log(err));
  }

  public updateInputNumber(event: any, property) {
    this.store[property] = Math.round(numeralService.parseToNumber(event.target.value) * 100) / 100 || 0;
  }

  public onSubmit() {
    this.$v.$touch();
    if (this.$v.$error) {
      return;
    }

    const $container: any = $(document.createElement('div'));
    $container.appendTo('body');

    if (this.store.isPermanent) {
      this.openConfiramation = true;
      //   const kendoConfirm: any = $container.kendoConfirm({
      //     width: '240px',
      //     title: false,
      //     content: 'Tem certeza de que deseja salvar as alteração de forma permanente',
      //      actions: [
      //             { text: 'Salvar', primary: true },
      //             { text: 'Cancelar'}
      //         ],
      //     close: () => {
      //       kendoConfirm.destroy();
      //       $container.remove();
      //     }
      //   }).data('kendoConfirm').open();

      //   kendoConfirm.result.done(() => {
      //     this.submitForm();
      //   });
    } else {
      this.submitForm();
    }
  }

  private submitForm() {
    this.openConfiramation = false;
    const store = _.cloneDeep(this.store);
    const idCity: any = store.idCity;
    store.idCity = idCity && idCity.value ? idCity.value : idCity;
    this.$emit('submit', store);
  }

  private cancelModalConfirmation() {
    this.openConfiramation = false;
  }

  public formatStoreType(storeType: string) {
    if (storeType) {
      return (_.find(this.storeTypeDataSource, (x: any) => x.value === storeType) as any).text;
    }
    return '';
  }

  @Emit('cancel')
  onCancel() {} // tslint:disable-line

  mounted() {
    const req = [addressService.getAllCities(), httpService.http.get(`${CONFIG.URL.NEODASH_API}/api/dap/groups`)];

    Promise.all(req)
      .then((res: AxiosResponse[]) => {
        this.cities = _.map(res[0].data, (d: any) => ({
          value: +d.idLocaleClient.trim(),
          text: d.name.split(',')[0].trim(),
          city: d.name.split(',')[0].trim(),
          state: (d.name.split(',')[1] || 'PE').trim(),
          operationType: d.localeOperationType ? d.localeOperationType.name : '',
          percentGrowth: d.localeOperationType ? d.localeOperationType.percentGrowth : 0,
          percentConversion: d.localeOperationType ? d.localeOperationType.centConversion: 0,
          percentRate: d.localeOperationType ? (d.localeOperationType ? d.localeOperationType.percentGrowthx : 0) : 0
        }));
        this.groupsDataSource = res[1].data;
      })
      .catch(err => {
        console.log(err);
      });
  }
}
